var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20V7.914a1 1 0 00-.293-.707l-3.914-3.914A1 1 0 0016.086 3H16v5a1 1 0 01-1 1H9a1 1 0 01-1-1V3H4a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1zM8 14.5a2 2 0 00-2 2v3h12v-3a2 2 0 00-2-2H8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7V3h1.5v4h-1.5z",
    fill: "#fff"
  })));
}
export default SvgSave;